import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=78221318&scoped=true&"
var script = {}
import style0 from "./IconDelete.vue?vue&type=style&index=0&id=78221318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78221318",
  null
  
)

export default component.exports